export default __webpack_public_path__ + "static/media/7.84586cf9.jpg";